import { render, staticRenderFns } from "./DataPrivacyView.vue?vue&type=template&id=0138eee2"
import script from "./DataPrivacyView.vue?vue&type=script&lang=js"
export * from "./DataPrivacyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports